import MainApi from "./axiosInstance";
import Urls from "../utils/constants/urls";
import URLS from "../utils/constants/urls";

class DriverService {
    getAllDrivers(afterId?: string | null) {
        return MainApi.get(afterId ? `${ Urls.drivers}?afterId=${afterId}` : Urls.drivers)
    }

    deleteDriver(id: string) {
        return MainApi.delete(`${URLS.drivers}/${id}`)
    }

    fetchDriverRatings(id: string) {
        return MainApi.get(`/driver-ratings?driverId=${id}`)
    }

    createDriver(payload: any) {
        return MainApi.post(URLS.drivers, payload)
    }


}

export default new DriverService()